import { Logo } from "../Logo";

export function SettingsShimmerLoader() {
  return (
    <div>
      {/* Mobile top bar */}
      <div className="sticky top-0 z-40 flex items-center gap-x-6 bg-white px-4 py-4 shadow-sm sm:px-6 lg:hidden border-b border-gray-200">
        <div className="h-5 w-5 rounded shimmer" />
        <div className="flex-1 flex items-center gap-2">
          <Logo className="h-6 w-auto" />
          <span
            className="text-2xl font-semibold text-gray-900"
            style={{ fontFamily: "'Questrial', sans-serif" }}
          >
            fluvo
          </span>
        </div>
      </div>

      {/* Desktop sidebar */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
        <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white">
          {/* Logo */}
          <div className="flex h-16 shrink-0 items-center px-4">
            <div className="flex items-center gap-2">
              <Logo className="h-4 w-auto" />
              <span
                className="text-2xl font-semibold text-gray-900"
                style={{ fontFamily: "'Questrial', sans-serif" }}
              >
                fluvo
              </span>
            </div>
          </div>

          {/* Sidebar nav */}
          <nav className="flex flex-1 flex-col px-4 mt-4">
            <ul className="flex flex-1 flex-col gap-y-7">
              <li>
                <div className="text-xs/6 font-semibold text-gray-400">
                  Settings
                </div>
                <ul className="-mx-2 mt-2 space-y-1">
                  {["User Details", "Brand Kit", "Database Connection", "Manage Payment", "Workflow Activation"].map((label, i) => (
                    <li key={i}>
                      <div className={`flex w-full gap-x-3 rounded-md p-2 ${i === 0 ? "bg-gray-50" : ""}`}>
                        <div className="h-6 w-6 shrink-0 rounded shimmer" />
                        <div
                          className="h-5 rounded-full shimmer"
                          style={{ width: `${80 + label.length * 3}px` }}
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              </li>

              {/* Back to Dashboard */}
              <li className="-mx-4 mt-auto">
                <div className="flex items-center gap-x-4 px-4 py-3">
                  <div className="size-8 shrink-0 rounded-full shimmer" />
                  <div className="h-4 w-32 rounded-full shimmer" />
                </div>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      {/* Main content */}
      <div
        className="lg:pl-72"
        style={{
          display: "flex",
          flexDirection: "row",
          height: "100vh",
          minHeight: 0,
        }}
      >
        <main
          className="bg-white"
          style={{ flex: 1, minWidth: 0, overflowY: "auto" }}
        >
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {/* Page title */}
            <div className="mb-8">
              <div className="h-8 w-40 rounded-full shimmer" />
              <div className="h-4 w-72 rounded-full shimmer mt-3" />
            </div>

            {/* Tab content — mimics UserDetailsTab (default tab) */}
            <div className="mt-8 space-y-8">
              {/* Section 1: User Information */}
              <div>
                <div className="h-5 w-36 rounded-full shimmer" />
                <div className="h-3 w-64 rounded-full shimmer mt-2" />
                <div className="border-b border-gray-200 mt-4" />

                <div className="mt-6 space-y-5">
                  {/* Field 1 */}
                  <div>
                    <div className="h-4 w-28 rounded-full shimmer" />
                    <div className="h-10 w-full rounded-md shimmer mt-2" />
                  </div>
                  {/* Field 2 */}
                  <div>
                    <div className="h-4 w-32 rounded-full shimmer" />
                    <div className="h-10 w-full rounded-md shimmer mt-2" />
                  </div>
                  {/* Save button */}
                  <div className="h-10 w-32 rounded-md shimmer mt-2" />
                </div>
              </div>

              {/* Section 2: Change Password */}
              <div>
                <div className="h-5 w-40 rounded-full shimmer" />
                <div className="h-3 w-56 rounded-full shimmer mt-2" />
                <div className="border-b border-gray-200 mt-4" />

                <div className="mt-6">
                  <div className="h-10 w-48 rounded-md shimmer" />
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
